/**
 * @copyright Elmelo Ltd.
 */

import React from 'react'

import { Router } from "@reach/router"

import GalleryHome from './home'

import P404 from '../_common/404'

/**
 */
class App_Gallery extends React.PureComponent
{
    /**
     */
    // constructor( props )
    // {
    //     super( props )
    // }

    /**
     */
    render()
    {
        return (
            <Router>
                <GalleryHome path='home'/>

                <P404 default />
            </Router>
            )
    }   // render
}   // class App_Gallery

/**
 */
export {App_Gallery, GalleryHome}
